/**
 * ファイルドロップエリア
 * クリックでファイル選択・ドラッグ&ドロップ対応
 * 対象: .m-contact-form__file-drop を持つ要素
 */
export function fileDrop() {
  const dropAreas = document.querySelectorAll('.m-contact-form__file-drop');
  if (!dropAreas.length) return;

  // ファイルサイズを人間が読める形式に変換
  const formatSize = (size) => {
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
    return `${(size / (1024 * 1024)).toFixed(1)} MB`;
  };

  dropAreas.forEach((dropArea) => {
    const fileInput = dropArea.querySelector('input[type="file"]');
    const fileText = dropArea.querySelector('.m-contact-form__file-text');
    if (!fileInput || !fileText) return;

    const defaultText = fileText.textContent;

    // ファイル選択後のフィードバック
    const applyFile = (file) => {
      if (file) {
        fileText.textContent = `${file.name}（${formatSize(file.size)}）`;
        dropArea.classList.add('is-selected');
        dropArea.classList.remove('is-dragover');
      } else {
        fileText.textContent = defaultText;
        dropArea.classList.remove('is-selected');
      }
    };

    // クリックでファイル選択ダイアログを起動
    dropArea.addEventListener('click', () => {
      fileInput.click();
    });

    // input change
    fileInput.addEventListener('change', () => {
      applyFile(fileInput.files?.[0] ?? null);
    });

    // ドラッグ&ドロップ
    dropArea.addEventListener('dragover', (e) => {
      e.preventDefault();
      dropArea.classList.add('is-dragover');
    });

    dropArea.addEventListener('dragleave', (e) => {
      if (!dropArea.contains(e.relatedTarget)) {
        dropArea.classList.remove('is-dragover');
      }
    });

    dropArea.addEventListener('drop', (e) => {
      e.preventDefault();
      const file = e.dataTransfer.files?.[0];
      if (!file) return;

      // input にファイルをセット
      const dt = new DataTransfer();
      dt.items.add(file);
      fileInput.files = dt.files;

      applyFile(file);
    });
  });
}
